import { InfoOutlined } from '@mui/icons-material';
import React, { useState } from 'react';

import { updateStateAttribute } from '../helpers/helper';
import CButton from './CButton';
import CModal from './CModal';
import CPageModule from './CPageModule';

interface Props {
  children: React.ReactNode;
  title?: React.ReactNode;
}

interface State {
  showModal: boolean;
}

export default function CInfoButtonWithModal(props: Props) {
  const [state, setState] = useState<State>({ showModal: false });

  return (
    <div className={'flex gap-2 items-center justify-center'}>
      <CButton
        style={{borderWidth: 1}}
        onClick={() => {
          updateStateAttribute<State>({ showModal: true }, setState);
        }}
      >
        <InfoOutlined />
      </CButton>
      <CModal
        onClose={() => {
          updateStateAttribute<State>({ showModal: false }, setState);
        }}
        open={state.showModal}
      >
        <CPageModule fullWidth style={{paddingTop: 0, paddingBottom: 0}}>
          {props.title && <h4>{props.title}</h4>}
          {props.children}
        </CPageModule>
      </CModal>
    </div>
  );
}
